import { toast } from '@/helpers/toast/toast.helper'
import { put } from 'redux-saga/effects'
import { resendTwoFactorCodeAsync } from '../../actions'
import { api } from '@/services/api'

export function* resendTwoFactorCodeSaga(action: ReturnType<typeof resendTwoFactorCodeAsync.request>) {
  try {
    const { preAuthTicket } = action.payload
    yield api.post('/sign-in-owner/2fa/resend', { preAuthTicket })
    yield toast({ type: 'success', message: 'Código reenviado com sucesso!' })
    yield put(resendTwoFactorCodeAsync.success())
  } catch (error) {
    const message = error.response?.data?.message || error.message
    yield toast({ type: 'error', message: 'Erro ao reenviar código. Tente novamente.' })
    yield put(resendTwoFactorCodeAsync.failure({ message }))
  }
}
